// extracted by mini-css-extract-plugin
module.exports = {"info":"notification-message_info__1Th5G","infoContent":"notification-message_infoContent__d5f-T","infoContentText":"notification-message_infoContentText__17ZzB"};